import React from 'react';
import { Icon, IconComponent } from '@flixbus/honeycomb-icons-react';

import styles from './voucher-overview.module.scss';

interface VoucherOverviewItemProps {
  icon: IconComponent;
  content: React.ReactNode;
  disabled?: boolean;
}

const VoucherOverviewItem = ({ icon, content, disabled }: VoucherOverviewItemProps) => {
  return (
    <div className={styles.item}>
      <div className={styles.icon}>
        <Icon size={6} InlineIcon={icon} extraClasses={disabled ? styles.iconDisabled : ''}></Icon>
      </div>
      <div>{content}</div>
    </div>
  );
};

export default VoucherOverviewItem;
